import { Document } from '@contentful/rich-text-types'
import { ReactElement } from 'react'
import styled from 'styled-components'

import { typeStyleMap } from '@syconium/little-miss-figgy'
import { fromMd } from '@syconium/little-miss-figgy/dist/constants'

import { ContentfulRichText } from '../../../../app/_components/pages/contentful/components/ContentfulRichText'

const SeoContentRichTextSectionWrapper = styled.div`
  border-top: 1px solid ${o => o.theme.color.deprecated.stone};
  margin: 0 16px;
  padding: 50px 22px 128px;

  ${fromMd} {
    margin: 0 40px;
    padding-bottom: 103px;
  }

  display: flex;
  justify-content: center;
  align-items: center;
`

const SeoContentRichTextSection = styled(ContentfulRichText)`
  margin: auto;
  text-align: center;

  ${fromMd} {
    max-width: 600px;
  }

  h1,
  h2,
  h3 {
    ${typeStyleMap.headlineExtraExtraSmall};
  }

  p {
    ${typeStyleMap.bodySmall};
    color: ${o => o.theme.color.text.secondary.on.background};
  }
`

export const SeoContent = ({ content }: { content: Document }): ReactElement | null => {
  return (
    <SeoContentRichTextSectionWrapper>
      <SeoContentRichTextSection content={content} />
    </SeoContentRichTextSectionWrapper>
  )
}
